/**
 * Load a template dynamically.
 *
 * This is essentially a fairly simple replacement for
 * require.js specifically handling the loading of templates.
 *
 * It will retry templates that fail and has basic IE8 support.
 */

'use strict';

exports.__esModule = true;
exports.script = script;
exports.scripts = scripts;
exports.json = json;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var MAX_TRIES = 3; // try a few times in case of failing template
var RETRY_WAIT = 250; // plenty of time for the templates to start loading...

// a few placeholders...
var callbacks = {};
var tries = {};

/**
 * Simple logger, really helpful for debugging.
 * @param message
 */
function log(message) {
	if (window.console) {
		console.error(message); // eslint-disable-line no-console
	}
}

/**
 * Simple script loader.
 *
 * Basically a copy of http://www.dustindiaz.com/scriptjs, except
 * it includes support for retries and a callback queue to avoid
 * re-adding the same script tag more than once.
 *
 * @param url
 * @param callback
 * @param forceAttempt
 */

function script(url) {
	var callback = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
	var forceAttempt = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

	var scriptEl = document.createElement('script');
	var loaded = false;

	// add to the callback queue
	callbacks[url] = callbacks[url] ? callbacks[url] : [];
	callbacks[url].push(callback);

	// return if callbacks queue already started
	if (!forceAttempt && callbacks[url].length > 1) {
		return;
	}

	// update the try count
	tries[url] = tries[url] ? tries[url] : 0;
	tries[url]++;

	// give up after trying a few times
	if (tries[url] === MAX_TRIES) {
		log('Giving up on ' + url + ' after ' + MAX_TRIES + ' tries');
		return;
	}

	// handle on load
	scriptEl.onload = scriptEl.onreadystatechange = function () {
		if (scriptEl.readyState && scriptEl.readyState !== 'complete' && scriptEl.readyState !== 'loaded' || loaded) {
			return false;
		}
		scriptEl.onload = scriptEl.onreadystatechange = null;
		loaded = true;

		// drain the callbacks (w/forced async)
		setTimeout(function () {
			callbacks[url].forEach(function (cb) {
				if (typeof cb === 'function') {
					cb(); // eslint-disable-line callback-return
				}
			});
			delete tries[url];
			delete callbacks[url];
		}, 0);
	};

	// retry on errors
	scriptEl.onerror = function () {
		log('Error loading ' + url + ' ...trying again');

		// force the script loader to try again without a new callback
		setTimeout(function () {
			return script(url, function () {}, true);
		}, RETRY_WAIT);
	};
	scriptEl.async = true;
	scriptEl.src = url;
	document.getElementsByTagName('head')[0].appendChild(scriptEl);
}

function scripts(urls) {
	urls.forEach(script);
}

function json(url) {
	var jqueryPromise = _jquery2['default'].ajax({
		url: url,
		dataType: 'json',
		ignoreErrors: true
	});

	// convert jquery promise into a real promise
	return Promise.resolve(jqueryPromise)['catch'](function (error) {
		error.url = url; // save the URL for using later
		throw error;
	});
}


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/forklifter/dist/ajax.js
// module id = 477
// module chunks = 0